class SimpleSelect {
  constructor(options) {
    this.options = options || {};
    this.count = 1;
    this.scrollPos = 0;
    this.body = document.body;
    if (document.querySelector('[data-ref="peoples-dropdown"]') == null) return;
    this.intro = document.querySelector('[data-ref="peoples-intro"]');
    this.sectionWrapper = document.querySelector('[data-ref="peoples-list"]');
    this.init();
  }

  init() {
    this.isOpen = false;
    this.count = this.count + 1;
    this.bindUI();
    this.createCustomSelect();
    if (document.querySelector('.customS-wrapper') == null) this.createOptions();
    this.bindEvents();
    const event = new CustomEvent('select:created');

    setTimeout(() => {
      window.dispatchEvent(event);
    }, 300);
  }

  bindUI() {
    this.params = {
      select: this.options.element,
      name: this.options.element.hasAttribute('name') ? this.options.element.getAttribute('name') : `customselect${this.count}`,
      container: document.querySelector(this.options.container),
    };

    return this.params;
  }

  createCustomSelect() {
    // create fake select and append it to container div passes as param of class
    const customSelect = document.createElement('div');
    customSelect.className = `customS ${this.params.name}`;
    this.params.container.append(customSelect);
  }

  createOptions() {
    const selectedIndex = this.params.select.options[0];

    const optionGroup = [...this.params.select.querySelectorAll('optgroup')];
    const optionsLength = this.params.select.querySelectorAll('option').length;

    const customWrapper = document.createElement('div');
    customWrapper.className = 'customS-wrapper';

    optionGroup.forEach((group) => {
      const options = [...group.querySelectorAll('option')];
      const label = group.getAttribute('label');

      const customOptionWrapper = document.createElement('ul');
      customOptionWrapper.className = 'customS__list';

      // create fake options and append them to ul then appen ul to wrapper
      for (let i = 0; i < options.length; i++) {
        const customOption = document.createElement('li');

        customOption.className = 'customS__option type-body';


        const customOptionSpan = document.createElement('span');
        customOptionSpan.className = 'customS__option-inner';

        const optEl = options[i];
        let index = optEl.getAttribute('data-index');

        const optElText = optEl.textContent;
        const optElValue = optEl.hasAttribute('value') ? options[i].getAttribute('value') : optElText;

        customOptionSpan.textContent = optElText;
        customOption.setAttribute('data-index', index);
        customOption.setAttribute('data-value', optElValue);


        if (optEl.hasAttribute('data-manager')) {
          customOption.setAttribute('data-manager', true);
        }

        if (optEl.hasAttribute('data-location')) {
          customOption.setAttribute('data-location', optEl.getAttribute('data-location'));
        }


        if (optEl.getAttribute('data-index') === '0') {
          customOption.classList.add('customS__option--disabled');
        }

        if (customOption.getAttribute('data-manager')) {
          customOption.classList.add('customS__option--hidden');
        }


        customOption.append(customOptionSpan);
        customOptionWrapper.append(customOption);
        customWrapper.append(customOptionWrapper);
        index++;
      }

      if (label != null) {
        const labelTitle = document.createElement('li');
        labelTitle.className = 'customS__title u-mb--space-xs type-body-s';
        labelTitle.textContent = label;

        customOptionWrapper.prepend(labelTitle);
      }
      document.querySelector(`.${this.params.name}`).append(customWrapper);
    });


    // create current fake option
    if (window.innerWidth < 1100) {
      const currentOption = document.createElement('div');
      currentOption.className = 'customS__current';

      const currentOptionName = document.createElement('div');
      currentOptionName.className = 'customS__current-name';

      // index - total
      const total = document.createElement('div');
      total.className = 'total';
      total.textContent = optionsLength < 10 ? `0${optionsLength}` : optionsLength;

      const spacer = document.createElement('div');
      spacer.className = 'spacer';
      spacer.innerHTML = '&nbsp;-&nbsp;';

      const currentIndex = document.createElement('div');
      currentIndex.className = 'current';
      if (selectedIndex.getAttribute('data-index') > 0 && selectedIndex.getAttribute('data-index') < 10) {
        currentIndex.textContent = `0${selectedIndex.getAttribute('data-index')}`;
      } else {
        currentIndex.textContent = selectedIndex.getAttribute('data-index');
      }

      const currentTotal = document.createElement('div');
      currentTotal.className = 'customS__current-total type-caption';

      currentTotal.append(currentIndex);
      currentTotal.append(spacer);
      currentTotal.append(total);

      // add name and total to wrapper
      currentOption.append(currentOptionName);
      currentOption.append(currentTotal);


      currentOptionName.textContent = selectedIndex.textContent;
      currentOption.setAttribute('data-value', selectedIndex.textContent);
      currentOption.setAttribute('data-index', selectedIndex.getAttribute('data-index'));
      currentOption.setAttribute('data-manager', selectedIndex.getAttribute('data-manager'));
      currentOption.setAttribute('data-location', selectedIndex.getAttribute('data-location'));
      document.querySelector(`.${this.params.name}`).prepend(currentOption);
    }
  }

  bindEvents() {
    if (window.innerWidth < 1100) {
      document.querySelector(`.${this.params.name}`).addEventListener('click', this.toggle.bind(this));
    }

    if (window.innerWidth > 1100) {
      document.querySelector('.peopleList-header').addEventListener('click', this.clickAway.bind(this));

      const childList = document.querySelectorAll(`.${this.params.name} .customS__option`);

      for (let i = 0; i < childList.length; i++) {
        childList[i].addEventListener('click', this.onChildClick.bind(this));
      }

      // window.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  // onScroll() {
  //   // detects new state and compares it with the new one
  //   if ((document.body.getBoundingClientRect()).top > this.scrollPos) {
  //     this.emptyState();
  //   }

  //   // saves the new position for iteration.
  //   this.scrollPos = (document.body.getBoundingClientRect()).top;
  // }

  toggle(e) {
    if (this.isOpen) {
      this.close(e);
      this.isOpen = false;
    } else {
      this.open(e);
      this.isOpen = true;
    }
  }

  clickAway() {
    this.emptyState();
  }

  open(e) {
    const target = e.currentTarget;

    if (!target.matches(`.${this.params.name}`)) return;

    const customWrapper = target.querySelector('.customS-wrapper');
    const customCurrent = target.querySelector('.customS__current');

    customWrapper.classList.add('is-active');
    customCurrent.classList.add('customS__current--open');
    // this.body.style.overflow = 'hidden';

    const childList = customWrapper.querySelectorAll('.customS__option');

    for (let i = 0; i < childList.length; i++) {
      childList[i].addEventListener('click', this.onChildClick.bind(this));
    }
  }

  close(e) {
    const target = e.currentTarget;

    if (!target.matches(`.${this.params.name}`)) return;

    const customWrapper = target.querySelector('.customS-wrapper');
    const customCurrent = target.querySelector('.customS__current');

    customWrapper.classList.remove('is-active');
    customCurrent.classList.remove('customS__current--open');
    // this.body.removeAttribute('style');
  }

  emptyState() {
    this.intro.removeAttribute('style');
    this.sectionWrapper.removeAttribute('style');
    const childList = document.querySelectorAll('.customS__option');
    for (let i = 0; i < childList.length; i++) {
      childList[i].classList.remove('is-active');
    }
  }

  updateDisplay() {
    this.intro.style.transform = 'translateY(-100%)';
    this.intro.style.opacity = '0';
    this.intro.style.display = 'none';
    this.sectionWrapper.style.transform = 'translateY(0)';
    this.sectionWrapper.style.opacity = '1';
  }

  onChildClick(e) {
    const target = e.currentTarget;
    const parent = target.closest('.customS');

    this.updateDisplay();

    const index = target.getAttribute('data-index');

    if (window.innerWidth < 1100) {
      const currentOption = parent.querySelector('.customS__current');
      const currentOptionName = parent.querySelector('.customS__current-name');
      const currentOptionCurrent = parent.querySelector('.customS__current-total .current');

      currentOptionName.textContent = target.textContent;
      if (target.getAttribute('data-index') > 0 && target.getAttribute('data-index') < 10) {
        currentOptionCurrent.textContent = `0${target.getAttribute('data-index')}`;
      } else {
        currentOptionCurrent.textContent = target.getAttribute('data-index');
      }
      currentOption.setAttribute('data-value', target.textContent);
      currentOption.setAttribute('data-index', target.getAttribute('data-index'));
    }

    const childList = parent.querySelectorAll('.customS__option');
    for (let i = 0; i < childList.length; i++) {
      childList[i].classList.remove('is-active');
    }

    target.classList.add('is-active');

    target.addEventListener('click', this.bindChange(index));
  }

  bindChange(optionIndex) {
    if ( optionIndex != null) {
      const option = this.params.select.options[optionIndex];
      option.selected = true;
      /* eslint-disable */
      this.params.select.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }
}

export default SimpleSelect;
